module.exports = __webpack_public_path__ + "img/qqd.4024348a.png";